import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { BomItem } from '../bom/bomUtils'
import VerticalSpacer from '../components/VerticalSpacer'

const CashSalesAddToCartConfirmPopup: React.FC<{
  onConfirm: () => void
  onCancel: () => void
  bom: readonly BomItem[]
}> = ({
  onConfirm,
  onCancel,
  bom,
}) => {
  return (
    <Popup onClose={onCancel}>
      <div className="title">
        Add to Cash Sales cart
      </div>
      <div>
        <p>
          Would you like to add your bill of materials to your Cash Sales cart?
        </p>
        <p>
          {bom.length} product{bom.length !== 1 ? 's' : ''} will be added.
        </p>
      </div>
      <VerticalSpacer />
      <div className="buttonStack">
        <div className="buttonRow">
          <Button buttonStyle="green" onClick={onConfirm}>
            Add to cart
          </Button>
        </div>
        <Button onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </Popup>
  )
}

export default CashSalesAddToCartConfirmPopup